import _ from "lodash";
import React from "react";
import classNames from "classnames";
import { StandardTableSortableHeader } from "../../../components/tables/StandardTable";
import { useUsersGridData } from "../hooks/UsersGridContext";

const UsersGridTableHeader = ({ children, property, className }) => {
    const { sort, sortTable } = useUsersGridData();
    const sortProperties = sort.split(',');
    const isHeaderSorted = _.some(sortProperties, i => i.includes(property));
    const headerDirection = isHeaderSorted && _.some(sortProperties, i => i.toLowerCase().includes('+desc')) ? "desc" : null;

    const handleClick = () => sortTable(property);

    return (
        <StandardTableSortableHeader
            className={classNames(className)}
            active={isHeaderSorted}
            direction={headerDirection}
            onClick={handleClick}
            isSticky={true}
        >
            {children}
        </StandardTableSortableHeader>
    );
};

export default UsersGridTableHeader;